import { JsonObject, JsonProperty } from 'json2typescript';
import TemplateFooter from './TemplateFooter';
import TemplateHeader from './TemplateHeader';

@JsonObject('Template')
export default class Template {
  constructor() {
    this.templateCode = undefined;
    this.templateTitle = undefined;
    this.titleBackgroundCss = undefined;
    this.templateHeaders = new Array<TemplateHeader>();
    this.templateFooters = new Array<TemplateFooter>();
  }

  @JsonProperty('template_code')
  public templateCode?: string;

  @JsonProperty('template_title')
  public templateTitle?: string;

  @JsonProperty('title_background_css')
  public titleBackgroundCss?: string;

  @JsonProperty('template_headers', [TemplateHeader])
  public templateHeaders: Array<TemplateHeader>;

  @JsonProperty('template_footers', [TemplateFooter])
  public templateFooters: Array<TemplateFooter>;
}
